let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bNspF")).then(() => parcelRequire('fPKlu'));